import { ANSWER } from 'constants/answer';

export const cleanCDSLocations = data => {
  if (
    data.workPreferences?.relocation?.areYouWillingToRelocate === ANSWER.Negative &&
    data.workPreferences?.relocation?.relocationDestinations?.length > 0
  ) {
    return {
      ...data,
      workPreferences: {
        ...data.workPreferences,
        relocation: {
          ...data.workPreferences.relocation,
          relocationDestinations: []
        }
      }
    };
  }
  return data;
};
